import * as React from 'react'
import classNames from 'classnames'
import doggosIllustration from '../PageMyPets/doggos.png'
import * as style from './style.module.scss'

/**
 * Brand dogs illustration with the same subtle opacity pulse used while a
 * chat channel is opening.
 *
 * @param {'page' | 'inset' | 'fill' | 'dashboard'} [layout]
 *   page — full viewport boot screens
 *   inset — shorter centered placeholder (e.g. /search InstantSearch boot)
 *   dashboard — fixed viewport anchor shared by dashboard boot phases
 *   fill — stretch inside a flex column (chat message pane)
 */
export default function DoggosLoading({
  'aria-label': ariaLabel = 'Loading',
  layout = 'inset',
  className,
}) {
  return (
    <div
      aria-busy="true"
      aria-label={ariaLabel}
      aria-live="polite"
      className={classNames(
        style.root,
        layout === 'page' && style.page,
        layout === 'inset' && style.inset,
        layout === 'fill' && style.fill,
        layout === 'dashboard' && style.dashboard,
        className
      )}
      role="status"
    >
      <img
        alt=""
        aria-hidden
        className={style.illustration}
        src={doggosIllustration}
        width={1356}
        height={931}
      />
    </div>
  )
}
